<template>
    <transition name="form">
        <div v-if="isOpened">
            <div class="fixed z-80 w-screen h-screen inset-0 flex sm:items-center items-end justify-center" >
                <div class="w-full sm:max-w-xl px-6 mx-auto mb-12 relative">
                    <button class="absolute right-0 top-0 mt-2 mr-6 p-4 cursor-pointer focus:outline-none text-blue-900 hover:text-pink-500" @click="closeForm">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-6 w-6" viewBox="0 0 448 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/></svg>
                    </button>
                    <div class="bg-white rounded-lg px-8 py-4">
                        <div v-if="isSending" class="py-16 flex items-center justify-center flex-wrap text-blue-400">
                            <svg class="loadingAnimation fill-current w-16 h-16" viewBox="0 0 24 24">
                                <circle r="12" cx="12" cy="12"/>
                                <circle r="11.25" cx="12" cy="12" style="fill:#ffffff"/>
                                <rect x="9" y="0" height="4" width="6" style="fill:#ffffff"/>
                            </svg>
                            <p class="w-full text-center text-xl text-blue-600 pt-5">Sending your message..</p>

                        </div>
                        <div v-else-if="isCompleted" class="py-16">
                            <div class="text-4xl font-bold font-serif">Thank you!</div>
                            <p class="font-semibold">Your message has been send. We will reach out to you as soon as possible!</p>

                        </div>
                        <div v-else>
                            <div v-if="formtype == 'calling'">

                                <div class="text-4xl font-bold font-serif">Calling</div>
                                <p class="font-semibold">Make a call appointment with one of our specialists. Fill out the fields and we reach out to you.</p>

                                <div v-if="errorBag != null" class="bg-pink-500 -mx-3 text-white rounded px-3 my-2 py-2">
                                    <p class="font-semibold">The following errors has occurred:</p>
                                    <ul>
                                        <li v-for="error in errorBag">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>

                                <div class="flex flex-wrap pt-6 -mx-4" >
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="company" class="">Company:</label>
                                        <input type="text" id="company" v-model="company" class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="name" class="">Your name:</label>
                                        <input type="text" id="name" v-model="name"  class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="phone" class="">Phone:</label>
                                        <input type="text" v-model="phone"  id="phone" class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="email" class="">Email:</label>
                                        <input type="text" id="email" v-model="email"  class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-full px-4 mb-2">
                                        <p class="mb-3 font-semibold text-blue-700">When can we reach you?</p>
                                        <div class="">
                                            <label class="flex items-center mb-1 mr-8  cursor-pointer hover:cursor-pointer py-1 ">
                                                <div class="bg-white shadow-inner w-5 h-5 border border-blue-300 rounded-full mr-3 relative p-1">
                                                    <input type="radio" class="absolute w-full h-full opacity-0" v-model="date" name="date" value="As soon as possible" checked/>
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="hidden text-gray-600 fill-current " viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"/></svg>
                                                </div>
                                                <span class=" text-blue-700">Call me as soon as possible</span>
                                            </label>

                                            <label class="flex items-center mb-1 mr-8  cursor-pointer hover:cursor-pointer py-1 ">
                                                <div class="bg-white shadow-inner w-5 h-5 border border-blue-300 rounded-full mr-3 relative p-1">
                                                    <input type="radio" class="absolute w-full h-full opacity-0" v-model="date" name="date" value="Let's mail first"/>
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="hidden text-gray-600 fill-current " viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"/></svg>
                                                </div>
                                                <span class=" text-blue-700">Let's mail to make an appointment</span>
                                            </label>

                                        </div>



                                    </div>
                                </div>
                            </div>
                            <div v-else-if="formtype == 'email'">

                                <div class="text-4xl font-bold font-serif">Email</div>
                                <p class="font-semibold">Reach out to us by email. We’ll get back as soon as we can.</p>
                                <div v-if="errorBag != null" class="bg-pink-500 -mx-3 text-white rounded px-3 my-2 py-2">
                                    <p class="font-semibold">The following errors has occurred:</p>
                                    <ul>
                                        <li v-for="error in errorBag">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>

                                <div class="flex flex-wrap pt-6 -mx-4" >
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="company" class="">Company:</label>
                                        <input type="text" id="company" v-model="company" class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="name" class="">Your name:</label>
                                        <input type="text" id="name" v-model="name"  class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="phone" class="flex justify-between"><span class="block">Phone:</span><small class="block text-xs text-blue-500">(optional)</small></label>
                                        <input type="text" id="phone" v-model="phone"  class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="email" class="">Email:</label>
                                        <input type="text" id="email" v-model="email"  class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-full px-4 mb-2">
                                        <label for="description" class="">Short description of your challenge:</label>
                                        <textarea type="text" id="description" v-model="description"  class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"></textarea>
                                    </div>

                                </div>
                            </div>
                            <div v-else-if="formtype == 'videochat'">

                                <div class="text-4xl font-bold font-serif">Videochat</div>
                                <p class="font-semibold">Make an appointment for a video chat with one of our specialists. If you fill in this form, we reach out to you to make an appointment.</p>
                                <div v-if="errorBag != null" class="bg-pink-500 -mx-3 text-white rounded px-3 my-2 py-2">
                                    <p class="font-semibold">The following errors has occurred:</p>
                                    <ul>
                                        <li v-for="error in errorBag">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="flex flex-wrap pt-6 -mx-4" >
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="company" class="">Company:</label>
                                        <input type="text" id="company" v-model="company" class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="company" class="">Your name:</label>
                                        <input type="text" id="company" v-model="name" class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="company" class="flex justify-between"><span class="block">Phone:</span><small class="block text-xs text-blue-500">(optional)</small></label>
                                        <input type="text" v-model="phone" id="company" class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-1/2 px-4 mb-2">
                                        <label for="company" class="">Email:</label>
                                        <input type="text" id="company" v-model="email" class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"/>
                                    </div>
                                    <div class="w-full px-4 mb-2">
                                        <label for="company" class="">Short description of your challenge:</label>
                                        <textarea type="text" id="company" v-model="description" class="block w-full border border-blue-200 text-lg px-3 py-2 rounded"></textarea>
                                    </div>

                                </div>
                            </div>
                            <div class="flex justify-end pt-2">
                                <button class="button button--green" @click="sendForm">Send the form</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="fixed inset-0 bg-blue-900 opacity-90 h-screen w-screen text-6xl z-70"  ></button>
        </div>

    </transition>

</template>

<script>
    export default {
        name: "Contact-Popup",
        data: function(){
            return {
                'formtype': 'videochat',
                'isOpened': false,
                'isSending': false,
                'isCompleted': false,
                'errorBag': null,
                'action': null,
                'token': null,
                'params': null,

                'name': null,
                'email': null,
                'company': null,
                'phone': null,
                'description': null,
                'date': null
            }
        },
        methods: {
            'closeForm' : function(){
                this.errorBag = null;
                this.isOpened = false;
            },
            'sendForm': function(){
                this.isSending = true;
                this.errorBag = null;


                axios.post(this.action,{
                    '_token': this.token,
                    '_params': this.params,
                    'name' : this.name,
                    'company' : this.company,
                    'email' : this.email,
                    'phone' : this.phone,
                    'description' : this.description,
                    'date': this.date
                })
                    .then((response) => {
                        console.log(response);
                        this.isSending = false;
                        let responseData = response.data;
                        if (responseData.success == true){
                            this.isCompleted = true;
                        } else {
                            this.errorBag = responseData.errors;
                        }

                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })


            }
        },
        mounted: function() {


            let form = document.getElementById('contactPopup');
            this.action = form.getAttribute('action');
            let inputs = form.getElementsByTagName('input');
            let i;
            for(i = 0; i < inputs.length; i++){
                let input = inputs[i];
                let inputName = input.getAttribute('name');
                if (inputName == "_token"){
                    this.token = input.value;
                } else if (inputName == "_params"){
                    this.params = input.value;
                }
            }

            EventBus.$on('open-contact-modal', (formtype) => {
                this.formtype = formtype;
                this.isOpened = true;
            });
        },
        created() {
            const handleEscape = (e) => {
                if (e.key === 'Esc' || e.key === 'Escape' ) {
                    this.closeForm();
                }
            };
            document.addEventListener('keydown', handleEscape);
        },
        destroyed () {
            document.removeEventListener('keydown');
        }
    }
</script>
<style scoped>

</style>
